/**
 * Shared prompt composition for the providers that persist the split
 * authoring fields (persona / knowledge / instructions) next to the composed
 * `system_prompt` on their content block.
 *
 * Older scenarios only stored the composed prompt, so that is the fallback.
 */
export type PromptFields = {
  persona?: string;
  knowledge?: string;
  instructions?: string;
  system_prompt?: string;
};

export function composeBlockPrompt(block?: PromptFields | null): string {
  if (!block) return "";
  const parts = [block.persona, block.knowledge, block.instructions].filter(
    (s): s is string => !!s && s.trim().length > 0,
  );
  if (parts.length > 0) return parts.join("\n\n");
  return block.system_prompt ?? "";
}